export { exportForUnoCSS, exportIconSet } from './export'
export { syncIconsFromFigma } from './sync'
export type {
  ExportOptions,
  FigmaIconsConfig,
  FigmaIconsConfigFile,
  IconSourceConfig,
  SyncResult,
} from './types'

/**
 * 定义配置文件的辅助函数，提供类型提示
 */
export function defineConfig(config: import('./types').FigmaIconsConfigFile): import('./types').FigmaIconsConfigFile {
  return config
}

/**
 * 便捷方法：同步并导出
 */
export async function syncAndExport(
  config: import('./types').FigmaIconsConfig,
  outputPath: string,
) {
  const { syncIconsFromFigma } = await import('./sync')
  const { exportIconSet } = await import('./export')

  const result = await syncIconsFromFigma(config)

  if (!result.modified) {
    // eslint-disable-next-line no-console
    console.log('ℹ️  没有更新，跳过导出')
    return result
  }

  await exportIconSet(result.iconSet, {
    output: outputPath,
    pretty: true,
  })

  return result
}
